"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FocusManager = require("./FocusManager");
Object.keys(_FocusManager).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FocusManager[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FocusManager[key];
    }
  });
});